import React, { useState } from "react";
import { SUCURSALES, INICIALES, COLORES } from "../../utils/constants";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Resumen = ({ data, handleDelete, handleAplicaCupon, opcion= 0 }) => {


  const [codigoIngresado, setCodigoIngresado] = useState({})
  const [verCupones, setVerCupones] = useState(true)

  const handleCodigo = (e) => {
    setCodigoIngresado({
      ...codigoIngresado,
      [e.target.name]: e.target.value
    })
  }

  return (
    <div className={"/grid bg-primarioMira rounded-md mt-1 xl:mt-3  w-full /justify-center "}>
      <div className={"grid content-center"}>
        <p className={"text-white mx-auto font-medium text-2xl mt-2 text-center"}>
          Cursos seleccionados
        </p>
      </div>
      <div role="list" className="content-center p-4 mt-1 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 gap-1  sm:gap-6  mb-4 w-full mx-auto /bg-red-200">{/* w-full es de prueba*/}
        {data.map((project, index) => (
           ((project?.Seleccionado && project?.Pagar) || (project?.Cobrado) ) && 
           //(project.Orden === 1) &&
          <div key={index} className="animation-expand /-p-4 /showCard /max-w-sm p-2 mt-2  bg-secundarioMira rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 ring-1 ring-blueGray-50 elementFadeIn">

            <div className="|bg-green-200 w-full">
              <div className="flex flex-row w-full">
                {project.hasOwnProperty("Imagen") && project?.Imagen !== '' ?
                  <img
                    className={classNames(!project.Cobrado?"animate-pulse":"","w-10 mr-1")}
                    src={`./img/cursos/${project?.Imagen}`}></img>
                  : null}
                <p className="|mb-1 font-medium text-white text-sm my-auto">{project?.Cargo}</p>
              </div>
              <hr className="my-1"></hr>
              <p className="/mb-3 text-xs text-white">
                {project?.DescripcionPlan}
              </p>

              <div className="text-gray-400 flex flex-col xl:flex-row /justify-between text-sm p-0 justify-between xl:mr-2">
                <div className="inline-flex flex-col">
                  <p className="inline text-white mr-2">Inicio:</p> {project?.De}</div>
                <div className="inline-flex flex-col">
                  <p className="inline text-white |xl:ml-4 |mr-2">Fin:</p>{project?.A}</div>
              </div>

              {/* el cupon, condicional */}
              
              
            
              {/* el cupon, condicional */}
            </div>

            <div className="flex flex-row">
              <p className="text-white my-auto">Cupones aplicados:</p><p className={classNames(!project.Cobrado?"hidden":"","ml-2 text-secundario text-sm my-auto hover:underline cursor-pointer")} onClick={()=>setVerCupones(!verCupones)}>{!verCupones?"Ocultar detalle":"Ver detalle"}</p>
            </div>
            <div className={classNames((verCupones && project.Cobrado)?"hidden" : "", "w-full  divide-y divide-dashed")}>
              {
                project?.Cupones.map((cupon, index) => (
                  
                    
                  !cupon.Aplicar && !cupon.Aplicado? ( // condicion de aplicado || cupon.Aplicado
                    !project.Cobrado?
                    <div className={"flex flex-col //  p-1 rounded-sm"}>
                    
                    <div className="w-full flex flex-row">
                    <div className="w-3/4 justify-start">
                      <p key={index} className="text-gray-400 text-sm flex w-full">
                        {cupon.NombreCupon}
                      </p>
                    </div>
                    <div className="w-1/4 text-end flex flex-col justify-end">
                      <p key={index} className="text-secundario text-sm ">
                        Q.{cupon.ValorCupon}.00
                        </p>
                        </div>
                        
                        </div>
                        <div className="flex flex-col xl:flex-row w-full justify-between text-sm p-0 xl mr-2 gap-1 xl:gap-0">
                          <input type="text" className="rounded-md" name={`${(project.IdCargo + project.Orden + cupon.IdCupon)}`} placeholder="Ingrese código" onChange={(e)=> handleCodigo(e)}></input>
                          <button className="bg-azulBrillanteMira font-medium text-white rounded-md px-2 py-1 /my-2" onClick={(e) => handleAplicaCupon({IdCupon:cupon.IdCupon, Codigo:cupon.Codigo, IdCargo:project.IdCargo, Orden:project.Orden, CodigoIngresado: codigoIngresado, Nombre: `${(project.IdCargo + project.Orden + cupon.IdCupon)}`})}>
                          Aplicar cupón
                          </button>
                        </div>
                        
                        </div>
                        :
                        <div className="w-full flex  flex-row p-1 ">
                        <div className="w-3/4 justify-start">
                          <p key={index} className="text-gray-400 text-sm flex w-full">
                          {(cupon?.Aplicado || project?.Cobrado) ? "✔ ":null}  {cupon.NombreCupon}
                          </p>
                        </div>
                        <div className="w-1/4 text-end flex flex-row justify-end self-end">
                          <p key={index} className="text-secundario text-sm ">
                            Q.{cupon.ValorCupon}.00
                            </p>
                            </div>
                            
                            </div>
                        )
                        :(

                          <div className="w-full flex flex-row p-1">
                          <div className="w-5/6  md:w-3/4 justify-start">
                          <p key={index} className="text-gray-400 text-sm flex w-full">
                          {cupon.Aplicar?"✔ ":null} {cupon.NombreCupon} 
                          </p>
                          </div>
                          <div className="w-1/6 md:w-1/4 self-end text-end">
                          <p key={index} className="text-secundario text-sm ">
                          Q.{cupon.ValorCupon}.00
                          </p>
                          </div>
                          
                          </div>
                          )
                ))
              }
              
              <div className="flex flex-row justify-between ">
                <p className="text-gray-200 text-sm mt-2 px-1">Total descuento:</p>
                <p className="text-sm text-secundario mt-2 font-medium px-1">Q.{project.Cobrado?
                project.Cupones.reduce((prev, next) => prev + next.ValorCupon, 0)
                :
                project.Cupones.filter(element => element.Aplicar).reduce((prev, next) => prev + next.ValorCupon, 0)
              }.00</p>
              </div>
            </div>

            {!project?.Cobrado ? /* project?.precioAnterior */
              <div className="flex flex-row /xl:flex-col w-full justify-end gap-2">
                <div className="flex w-1/2 flex-col">
                  <p className="text-white text-sm m-auto">Sin descuento</p>
                  <p className={!project?.Cobrado ? "p-1 m-auto rounded-md /bg-red-500 inline /mx-auto font-medium text-sm xl:text-md tracking-tight text-red-500  line-through" : "inline mx-auto text-xs xl:text-sm tracking-tight  dark:text-white line-through text-secundarioMira"}>
                    Q {project.precioAnterior || (project.Valor)}.00
                  </p>
                </div>
                <div className="flex w-1/2 flex-col">
                  <p className="text-white text-sm m-auto">Ahora</p>
                  <p className="/bg-green-500 inline /mx-auto text-md xl:text-md font-medium tracking-tight text-green-500  |line-through p-1 rounded-md mx-auto">
                    Q {project?.Valor}.00
                  </p>
                </div>
              </div>
              :
              <div className="flex w-full flex-col xl:flex-row justify-between">
                <p className="text-white text-sm ">{!project?.Pagado && "Total"}</p>
                <p className=" text-md xl:text-md font-medium tracking-tight text-green-500 p-1 ">
                  {project?.Cobrado ? `PAGADO Q ${project?.Pagado}.00` : ` Q ${project?.Valor}.00`}
                </p>
              </div>
            }
            {project?.Cobrado &&
              <div className="flex w-full flex-col xl:flex-row justify-between">
                <p className="text-white text-sm  my-auto">Fecha de cobro</p>
                <p className=" text-md xl:text-md font-medium tracking-tight text-secundario p-1 my-auto">
                  {`${project?.FechaCobrado}`}
                </p>
                <p className="text-white text-sm my-auto">Recibo</p>
                <p className=" text-md xl:text-md font-medium tracking-tight text-secundario p-1 my-auto">
                  {`${project?.ReciboCobro}`}
                </p>
              </div>
            }
            <div className="flex justify-between |-mt-1 |xl:-mt-3 w-full">
              {INICIALES[project?.IdSede] &&
                <div className="flex flex-row  w-full my-2">
                  <div className=" w-3/4">
                    <p className={`inline text-${COLORES[project?.IdSede]}`}>{`${INICIALES[project?.IdSede]} - ${SUCURSALES[project?.IdSede]}`}</p>
                  </div>

                  {(!project?.Cobrado) &&
                    <div className="flex justify-end w-1/4">
                      <button
                        className=" inline py-1.5 px-1 xl:px-2 text-sm font-medium text-center text-white bg-azulBrillanteMira rounded-lg hover:bg-secundario hover:shadow-white shadow-sm"
                        onClick={() => handleDelete(index)}
                      >
                        Quitar
                      </button>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        ))}
      </div>
    </div>
  )
};

export default Resumen;
